import { AppData, BookingData, BookingTool, Step } from "../../AppDataProvider";

import { Mixpanel } from "../../../mixpanel";

export type BackFromMultiTierStepOpts = { appData: AppData };

const getPreviousStep = (
  bookingTool: BookingTool,
  bookingData: BookingData,
): Step => {
  const { forceServiceSelection, services, isGenericBookingTool } = bookingTool;
  const { organisation } = bookingData;

  const filteredServices = services.edges.filter(
    ({ node }) => node.organisation._id === organisation?._id,
  );

  if (
    isGenericBookingTool ||
    forceServiceSelection ||
    filteredServices.length !== 1
  ) {
    return "services";
  }

  return "organisations";
};

export const backFromMultiTierStep = ({
  appData,
}: BackFromMultiTierStepOpts): AppData => {
  Mixpanel.track({ name: "Went back", props: { from: "multiTier" } });

  const targetStep = getPreviousStep(appData.bookingTool, appData.bookingData);
  delete appData.bookingData.tier;

  return {
    ...appData,
    bookingData: appData.bookingData,
    currentStep: targetStep,
  };
};
